export const CHECK = ({ color, ...props }: React.ComponentPropsWithRef<'svg'>) => (
    <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M47 3L17.1724 35L3 19" stroke={color ?? "#FCFBF9"} strokeWidth="6" />
    </svg>
);
